module.exports = __webpack_public_path__ + "static/media/desktop-step3.02edfc99.png";